export default __webpack_public_path__ + "static/media/a024-11.56ae5756.svg";